import { Inject, Pipe, PipeTransform } from '@angular/core';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../config/hotel-tours-list-page.config";

@Pipe({
    name: 'priceFormat',
    standalone: true,
})
export class PriceFormatPipe implements PipeTransform {
  constructor(@Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig) { }

  transform(value: number, currency?: string): string {
    currency = this.hotelToursPageConfig.currencySigns[currency || 'kzt'];
    const newValue = ('' + value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return `${newValue} ${currency}`;
  }
}
